// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"7165a328","109":"310f440e","377":"a68fc8cf","651":"7165a328","867":"310f440e","991":"310f440e"}[chunkId] + ".chunk.css";
};